export const initAddCus = {
    addcusIsload: false,
    serverRegion: {},
    instanceTypeCloud: {},
    serverStatus: "",
};

export const addCusReducer = (state = initAddCus, action = {}) => {
    switch (action.type) {
        case 'DO_ADD_CUS_INITIAL': {
            return {
                ...state,
                ...initAddCus,
            };
        }
        case 'DO_LOADING_PROFILE_IMAGE': {
            return {
                ...state,
                addcusIsload: action.loading
            };
        }
        case 'GET_SERVER_REGION': {
            return {
                ...state,
                serverRegion: action.serverRegion
            };
        }
        case 'GET_INSTANCE_TYPE_CLOUD': {
            return {
                ...state,
                instanceTypeCloud: action.instanceTypeCloud
            };
        }
        case 'GET_SERVER_CONFIGURATION_DATA_STATUS': {
            return {
                ...state,
                serverStatus: action.serverStatus
            };
        }
        default:
            return {
                ...state
            };
    }
};
